import { FaCertificate, FaMedal } from "react-icons/fa";
import award from "../../assets/images/award.jpg";
import certificate from "../../assets/images/certificate.jpg";
import competition from "../../assets/images/competition.jpg";
import styles from "./ExtraCurricular.module.css";

const ExtraCurricular = () => {
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="3000"
      className="container my-5"
      id="extra"
    >
      <h1 className="text-center fw-bold text-uppercase">Extra Curricular</h1>
      <div>
        <h4 className="text-center">Honors and Awards</h4>
        <div className="row d-flex align-items-center my-5">
          <div className="col-lg-6">
            <img src={award} className="img-fluid w-100" alt="..." />
          </div>
          <div className="col-lg-6">
            <ul className={styles.ulStyle}>
              <li className={styles.liStyle}>
                <span className="fa-li">
                  <FaMedal />
                </span>{" "}
                <strong>Champion</strong> in Intra AUST Programming Contest Fall
                2018 (Senior Category) in 2019.
              </li>
              <br />
              <li className={styles.liStyle}>
                <span className="fa-li">
                  <FaMedal />
                </span>{" "}
                <strong>Runner-Up</strong> in Poster Presentation at Techfiesta
                2018 in 2018.
              </li>
              <br />
              <li className={styles.liStyle}>
                <span className="fa-li">
                  <FaMedal />
                </span>{" "}
                Won <strong>Shapla Cub Award</strong> of Bangladesh Scouts in
                2010.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div>
        <h4 className="text-center">Certifications</h4>
        <div className="row d-flex align-items-center my-5">
          <div className="col-lg-6">
            <ul className={styles.ulStyle}>
              <li className={styles.liStyle}>
                <span className="fa-li">
                  <FaCertificate />
                </span>{" "}
                <strong>Coursera:</strong>
                <ol className="mt-2">
                  <li className={styles.liStyle}>
                    Introduction to Data Science in Python
                  </li>
                  <li className={styles.liStyle}>
                    Natural Language Processing in Tensorflow
                  </li>
                </ol>
              </li>
              <br />
              <li className={styles.liStyle}>
                <span className="fa-li">
                  <FaCertificate />
                </span>{" "}
                <strong>HackerRank:</strong>
                <ol className="mt-2">
                  <li className={styles.liStyle}>Problem Solving (Basic)</li>
                  <li className={styles.liStyle}>Python (Basic)</li>
                  <li className={styles.liStyle}>Java (Basic)</li>
                  <li className={styles.liStyle}>SQL (Basic)</li>
                  <li className={styles.liStyle}>JavaScript (Basic)</li>
                </ol>
              </li>
              <br />
              <li className={styles.liStyle}>
                <span className="fa-li">
                  <FaCertificate />
                </span>{" "}
                <strong>FreeCodeCamp:</strong>
                <ol className="mt-2">
                  <li className={styles.liStyle}>
                    JavaScript Algorithms and Data Structures
                  </li>
                </ol>
              </li>
            </ul>
          </div>
          <div className="col-lg-6 order-first order-lg-last">
            <img src={certificate} className="img-fluid w-100" alt="..." />
          </div>
        </div>
      </div>
      <div>
        <h4 className="text-center">Participations and Problem Solving</h4>
        <div className="row d-flex align-items-center my-5">
          <div className="col-lg-6">
            <img src={competition} className="img-fluid w-100" alt="..." />
          </div>
          <div className="col-lg-6">
            <ol>
              <li className={styles.liStyle}>
                Hands-on Training session on Firebase and Google Cloud Platform
                organized by GDG Cloud Bangla in 2020.
              </li>
              <li className={styles.liStyle}>
                Intra AUST Programming Contest Spring 2019 and Project
                Showcasing (Software) in CodeWare 19 organized by AUST CSE
                Society.
              </li>
              <li className={styles.liStyle}>
                Tadhack Bangladesh 2018 hosted by hSenid Mobile and powered by
                bdApps & Robi.
              </li>
              <li className={styles.liStyle}>
                Microsoft Young Bangla Internship 2018.
              </li>
              <li className={styles.liStyle}>
                Intra AUST Programming Contest 2017.
              </li>
              <li className={styles.liStyle}>
                Solved 700+ offline and online problems in{" "}
                <a
                  className={styles.ojStyle}
                  href="https://www.codechef.com/users/asj16"
                >
                  CodeChef
                </a>
                ,{" "}
                <a
                  className={styles.ojStyle}
                  href="http://codeforces.com/profile/asj16"
                >
                  Codeforces
                </a>
                , Spoj,{" "}
                <a
                  className={styles.ojStyle}
                  href="https://www.hackerearth.com/@ahmadsubaktagin"
                >
                  HackerEarth
                </a>
                ,{" "}
                <a
                  className={styles.ojStyle}
                  href="https://www.hackerrank.com/asj16"
                >
                  HackerRank
                </a>
                ,{" "}
                <a
                  className={styles.ojStyle}
                  href="https://lightoj.com/user/subaktagin-j"
                >
                  LightOJ
                </a>
                ,{" "}
                <a className={styles.ojStyle} href="https://toph.co/u/asj_16">
                  Toph
                </a>
                ,{" "}
                <a
                  className={styles.ojStyle}
                  href="https://uhunt.onlinejudge.org/id/974120"
                >
                  UVA
                </a>{" "}
                and{" "}
                <a
                  className={styles.ojStyle}
                  href="https://leetcode.com/user9050b/"
                >
                  LeetCode
                </a>
                .
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtraCurricular;
